import React from "react";

import { Box } from "./components";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Box />
    </div>
  );
}

export default App;
